import React from "react";
import styles from "./Layout.module.scss";
import NavBar from "@/components/NavBar/NavBar";
import TopBar from "@/components/TopBar/TopBar";
import PagesNavigation from "@/components/PagesNavigation/PagesNavigation";
import { IAdminFireBase } from "@/store/models/admin.models";
import { useLocation } from "react-router-dom";

interface LayoutProps {
  admin: IAdminFireBase;
  pageNav?: boolean;
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({
  admin,
  children,
  pageNav = true,
}) => {
  const location = useLocation();

  return (
    <div className={styles.page}>
      <NavBar />
      <div className={styles.pageContent}>
        <TopBar currentUser={admin} />
        <hr className={styles.hr} />
        {pageNav && <PagesNavigation state={location.state} />}
        {children}
      </div>
    </div>
  );
};

export default Layout;

